import {Copyright, CopyrightType} from './Copyright'
import {CtaCampaign, CtaCampaignType} from './cta/CtaCampaign'
import {Footer, FooterType} from './footer/Footer'
import {Header, HeaderMobile} from './header/Header'
import {LinkType, PageData, WebshopChannelData} from '../../types'
import {Newsletter, NewsletterType} from './Newsletter'
import React, {RefObject, useEffect, useRef, useState} from 'react'
import {Subnavigation, SubnavigationType} from './Subnavigation'

import {CartIcon} from '../webshop/layout/cart/CartIcon'
import {CookieBanner} from '../../cookies/views/CookieBanner'
import {EditCms} from './EditCms'
import {HeroType} from './Hero'
import LastModified from './LastModified'
import {style} from '../../util/style'
import {useMediaQuery} from '@material-ui/core'

const styles = style('layout', ['cart'])

type LayoutType = SubnavigationType & {
	navigation: Array<LinkType>
	navigation_btn?: LinkType
	ctacampaign?: CtaCampaignType
	newsletter?: {form: NewsletterType}
	footer: FooterType
	copyright: CopyrightType
	hero?: HeroType
} & WebshopChannelData

export const Layout: React.FC<PageData & LayoutType> = (props) => {
	const {
		channel,
		subnavigation,
		navigation,
		navigation_btn,
		ctacampaign,
		newsletter,
		footer,
		copyright,
		project_key,
		id,
		is_admin,
		children,
		translations,
		main_pages
	} = props
	const newsletterData = newsletter?.form

	const headerRef = useRef<HTMLDivElement>()
	const [headerPosition, setHeaderPosition] = useState(0)

	const isMobile = useMediaQuery('(max-width:1024px)')

	useEffect(() => {
		const currHeader = headerRef?.current
		const cartHeight = currHeader?.offsetHeight
		const cartDistanceToTop = currHeader?.offsetTop
		setHeaderPosition(cartDistanceToTop + cartHeight)
	}, [])
	return (
		<>
			<EditCms is_admin={is_admin} project={project_key} id={id} />
			<div className={styles()}>
				{!isMobile && (
					<CartIcon
						project_key={project_key}
						main_pages={main_pages}
						mod="fixed"
						headerPosition={headerPosition}
					/>
				)}
				<Subnavigation
					subnavigation={subnavigation}
					translations={translations}
				/>
				<LayoutHeader innerHeaderRef={headerRef} {...props} />
				<div className={styles('content')}>{children}</div>
				<CtaCampaign {...ctacampaign} />
				<LastModified
					channel={channel}
					date={
						Date.parse(props.modified || props.created)
							? new Date(props.modified || props.created)
							: undefined
					}
				/>
				<Newsletter {...newsletterData} />
				<Footer
					{...footer}
					navigation={navigation}
					btn={navigation_btn}
					subnavigation={subnavigation}
				/>
				<Copyright {...copyright} />
				<CookieBanner />
			</div>
		</>
	)
}

const LayoutHeader: React.FC<
	PageData & LayoutType & {innerHeaderRef: RefObject<HTMLDivElement>}
> = (props) => {
	const {
		project_key,
		main_pages,
		navigation,
		navigation_btn: btn,
		hero,
		innerHeaderRef
	} = props
	const hasHeroImg = checkForHeroImage(hero)
	const isMobile = useMediaQuery('(max-width:1024px)')

	if (isMobile)
		return (
			<HeaderMobile
				{...props}
				project_key={project_key}
				main_pages={main_pages}
			/>
		)

	return (
		<Header
			project_key={project_key}
			main_pages={main_pages}
			navigation={navigation}
			btn={btn}
			heroimg={hasHeroImg}
			innerHeaderRef={innerHeaderRef}
		/>
	)
}

const checkForHeroImage = (hero: HeroType) => {
	return (
		hero?.image &&
		typeof hero.image === 'object' &&
		!(hero.image instanceof Array)
	)
}
